import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";
import { useEnableEmployeePTAndLWF } from "../../../queries/employeeQueries";
import { toast } from "react-toastify";

const EditOrAddPTAndLWF = ({ openModal, onCloseModal, employee, refetchData }) => {
  const {
    handleSubmit,
    control,
    reset,
  } = useForm({
    defaultValues: {
      professional_tax_enabled: false,
      lwf_enabled: false,
    },
  });

  const { mutate: updateEmployeePTAndLWF, isLoading } = useEnableEmployeePTAndLWF();

  useEffect(() => {
    if (openModal && employee?.pt_lwf_details) {
      reset({
        professional_tax_enabled: !!employee.pt_lwf_details.professional_tax_enabled,
        lwf_enabled: !!employee.pt_lwf_details.lwf_enabled,
      });
    }
  }, [openModal, employee, reset]);

  const onSubmit = (data) => {
    const payload = {
      employee_id: employee?.employee_id,
      ...data,
    };

    updateEmployeePTAndLWF(payload, {
      onSuccess: (res) => {
        if (res?.status) {
          toast.success(res?.message || "PT & LWF details updated successfully");
          onCloseModal();
          refetchData?.();
        } else {
          toast.error(res?.message || "Update failed");
        }
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      },
    });
  };

  return (
    <Modal open={openModal} onClose={onCloseModal} center>
      <div className="p-5 w-[380px]">
        <h2 className="text-lg text-[#1F2937] font-semibold mb-5">
          Edit/Add Professional Tax & LWF
        </h2>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
          {/* Professional Tax Toggle */}
          <div className="flex justify-between items-center">
            <p className="text-sm text-black font-medium">Enable Professional Tax</p>
            <Controller
              name="professional_tax_enabled"
              control={control}
              render={({ field }) => (
                <ToggleSwitch
                  checked={field.value}
                  getToggleState={(val) => field.onChange(val)}
                  disabled={isLoading}
                />
              )}
            />
          </div>

          {/* LWF Toggle */}
          <div className="flex justify-between items-center">
            <p className="text-sm text-black font-medium">Enable Labour Welfare Fund</p>
            <Controller
              name="lwf_enabled"
              control={control}
              render={({ field }) => (
                <ToggleSwitch
                  checked={field.value}
                  getToggleState={(val) => field.onChange(val)}
                  disabled={isLoading}
                />
              )}
            />
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              className="btn btn--border text-sm font-medium"
              onClick={onCloseModal}
            >
              Cancel
            </button>
            <button type="submit" className="btn text-sm font-medium" disabled={isLoading}>
              {isLoading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditOrAddPTAndLWF;
